import { UserListItemDto } from './userConfig'
import { MoneyDto } from './i18nConfig'
import { Billable } from './registration/timeConfig'
import { InvoiceSummaryDto, LineItemType } from './finance/invoiceConfig'
import { PriceSummaryDto } from './finance/financeConfig'

import { LineItemEntity } from '../hooks/finance/invoice/useLineItemEntities'
import { DimensionsDto } from '../v2/components/Form/Accounting/DimensionFields'
import { DateTime } from 'luxon'
import { parseDate } from '../helpers/dateHelper'

export type RegistrationSummaryDto = LineItemEntity & {
    created: string
    userId: string
    description: string
    rate: MoneyDto
}

export type RegistrationListItemDto = LineItemEntity & {
    user: UserListItemDto
    description: string
    rate: MoneyDto
}

export type RegistrationOverviewDto = RegistrationListItemDto & {
    invoice: InvoiceSummaryDto
    price: PriceSummaryDto
}

export type RegistrationMutationDto = {
    fileId: string
    userId: string
    date: string
    description: string
    rate: string
    rateTotal?: string // used in the interface
    currency: string
    emailInbound?: boolean
}

type Disbursement = {
    type?: string
    vatType: string
}

type FixedPrice = {
    type?: string
    vatType: string
    name: string
    longDescription: string
}

type FixedPriceDetails = {
    type?: FixedPriceType
    vatType: string
}

type Time = {
    duration: string
    billable: Billable
    category?: string
}

type Travel = {
    distance: string
    billable: Billable
}

export type DisbursementType = {
    id: string
    name: string
    description?: string
    vatType: string
}

export enum FixedPriceTypeVariant {
    Default = 'DEFAULT',
    Standalone = 'STANDALONE',
    Manual = 'MANUAL',
    Mock = 'MOCK',
}

export type FixedPriceType = {
    id: string
    code: string
    name: string
    variant: FixedPriceTypeVariant
    validFrom?: string
    validTo?: string
    description?: string
    longDescription?: string
    value?: string
    vatType?: string
    rate?: string
    currency?: string
    showStatement?: boolean
    prefillType?: LineItemType[]
    includingVat?: boolean
    accounting?: DimensionsDto
}

export type DisbursementListItemDto = RegistrationListItemDto & Disbursement
export type DisbursementMutationDto = RegistrationMutationDto & Disbursement
export type DisbursementOverviewDto = RegistrationOverviewDto & Disbursement
export type FixedPriceListItemDto = RegistrationListItemDto & FixedPriceDetails
export type FixedPriceMutationDto = RegistrationMutationDto & FixedPrice
export type FixedPriceOverviewDto = RegistrationOverviewDto & FixedPrice
export type TimeListItemDto = RegistrationListItemDto & Time
export type TimeMutationDto = RegistrationMutationDto & Time
export type TimeOverviewDto = RegistrationOverviewDto & Time
export type TimeSummaryDto = RegistrationSummaryDto & Time
export type TravelListItemDto = RegistrationListItemDto & Travel
export type TravelMutationDto = RegistrationMutationDto & Travel
export type TravelOverviewDto = RegistrationOverviewDto & Travel

export function isActiveFixedPriceType(type: FixedPriceType, date?: DateTime): boolean {
    if (!date) {
        date = DateTime.now().startOf('day')
    }
    return (
        (!type.validFrom && !type.validTo) ||
        (parseDate(type.validTo || '3000-01-01')
            .diff(date)
            .toMillis() >= 0 &&
            parseDate(type.validFrom || '1970-01-01')
                .diff(date)
                .toMillis() <= 0)
    )
}
